const searchTypes = {
    location: 1
}

export default searchTypes;
